<template>
  <div class="my-5 mx-5 my-sm-8 mx-sm-8">
    <!-- Header with Title and Import Action -->
    <v-row align="center" >
      <v-col class="text-start">
        <span class="textLight--text font-weight-medium text-h5">
          {{ $t("course.registration") }}
        </span>
      </v-col>
    </v-row>

    <!-- Main Registration and Import Tabs -->
    <v-row>
      <v-col cols="12">
        <v-tabs
          v-model="selectedTab"
          color="primary"
          background-color="transparent"
          class="mb-4"
        >
          <v-tab class="px-0 me-8 pe-4 py-4" style="min-width: 150px">
            {{ $t("course.registration") }}
          </v-tab>
          <v-tab class="px-0 me-8 pe-4 py-4" style="min-width: 200px">
            {{ $t("reports.bulkRegistration") }}
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="selectedTab" class="transparent">
          <v-tab-item :transition="false">
            <v-row :key="reRender" class="mt-1">
              <v-col cols="12" :md="createOrganization ? 7 : 8" class="mb-6">
                <bulk-registration
                  ref="bulkRegistration"
                  :selectedOrganization="selectedOrganization"
                  :hideAddBtn="createOrganization"
                  @reRender="reRenderBulk"
                  @add="createOrganization = true"
                  @hide="createOrganization = false"
                />
              </v-col>

              <v-col cols="12" :md="createOrganization ? 5 : 4">
                <create-organization
                  v-if="createOrganization"
                  @onOrganizationCreate="fetchNewOrganizations"
                />
              </v-col>
            </v-row>
          </v-tab-item>

          <v-tab-item :transition="false">
            <excel-registration-import
              @imported="handleImportedRows"
            />
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BulkRegistration from "../../course-module/components/BulkRegistration.vue";
import CreateOrganization from "../../organization-module/components/CreateOrganization.vue";
import ExcelRegistrationImport from "../components/ExcelRegistrationImport.vue";

export default {
  components: {
    BulkRegistration,
    CreateOrganization,
    ExcelRegistrationImport,
  },
  data() {
    return {
      reRender: 0,
      selectedOrganization: null,
      createOrganization: false,
      selectedTab: 0,
    };
  },
  apollo: {
  },
  methods: {
    reRenderBulk() {
      this.reRender++;
    },
    fetchNewOrganizations(id) {
      if (this.$refs.bulkRegistration) {
        this.$refs.bulkRegistration.refetchOrganizations();
      }
      this.selectedOrganization = id ? id : null;
      this.createOrganization = false;
    },
    openImportDialog() {
      this.selectedTab = 1;
    },
    handleImportedRows(importedRows) {
      if (!importedRows || !importedRows.length) return;
      const validUsers = importedRows.map(r => {
        const name = String(r.employeeName || r.name || "").trim();
        let firstName = name;
        let lastName = "";
        const spaceIndex = name.indexOf(" ");
        if (spaceIndex !== -1) {
          firstName = name.substring(0, spaceIndex).trim();
          lastName = name.substring(spaceIndex + 1).trim();
        }
        return {
          firstName,
          lastName,
          email: String(r.email || "").trim(),
          civilIdOrPassport: String(r.employeeId || "").trim(),
          designation: String(r.designation || "").trim(),
          department: String(r.department || "").trim(),
        };
      });
      if (this.$refs.bulkRegistration) {
        this.$refs.bulkRegistration.addImportedUsers(validUsers);
      }
      this.reRenderBulk();
    },
  },
};
</script>
